<app-system-loader />

<p-toast position="bottom-right"></p-toast>

<router-outlet />
